import { render } from "./ReportNavigationTabs.vue?vue&type=template&id=2e6dd7eb&scoped=true"
import script from "./ReportNavigationTabs.vue?vue&type=script&lang=js"
export * from "./ReportNavigationTabs.vue?vue&type=script&lang=js"

import "./ReportNavigationTabs.vue?vue&type=style&index=0&id=2e6dd7eb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6dd7eb"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QRouteTab,QTab});
